<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Ball Park</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h1 class="book-title">BALL PARK</h1>
<p> </p>
<p> </p>
<h2 class="book-author">John Farrow</h2>
<p> </p>
<p> </p>
<p> </p>
<p> </p>
<p> </p>
<p class="publisher-logo"><img alt="logo missing" height="47" src="images/logo.jpg" width="65"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5a549b06